const agent = {
  name: 'Open Houses',
  office: 'REMAX Key Properties',
  phone: '(541) 728-0033',
  email: 'info@rmkporegon.com',
  address: '42 NW Greenwood Ave. Bend, OR 97703',
  sparkAgentId: '20200218210256261936000000',
  headshotUrl: '/images/ryan-headshot.jpg', // Locally hosted agent headshot
};
export default agent;
